const state = {
  userInfo: '',
  orgInfo: '',
  permission: '',
  account: '',
  token: '',
  sessionKey: '',
  b2bDefSuppId: 0,
  shpInfo: '',
  cartCount: 0,
  curPage: '',
  godTypeList: [],
  naviBarItemList: [],
  shpSearchBar: [],
  cartList: [],
  trdActivitys: {}
}

export default state
